import { TileRoleRoute } from '@/types'
import { Roles } from '@/auth/azure/Roles'
import { faReceipt } from '@fortawesome/free-solid-svg-icons'
import { ManagementGridFactory } from '@/routes/admin/components/ManagementGrid/ManagementGridFactory'

export const ExpenseRoute: TileRoleRoute = {
  path: 'expense',
  text: 'Spesa',
  faIcon: faReceipt,
  element: (
    <ManagementGridFactory
      entity="tipologia_spesa"
      referencesCollection="spese"
      referencesTitle="Spese"
      displayField="ded_Dis"
    />
  ),
  handle: {
    crumb: () => ({
      label: 'Spesa',
      icon: faReceipt,
    }),
  },
  mainMenuRoute: false,
  tile: true,
  allowedRoles: [Roles.GlobalAdministrator],
}
